export function preloadImage(src: string): Promise<void> {
  return new Promise((resolve) => {
    const done = () => resolve()
    const img = new Image()
    img.decoding = 'async'
    img.onload = () => {
      if (typeof img.decode === 'function') {
        void img.decode().then(done, done)
        return
      }
      done()
    }
    img.onerror = done
    img.src = src
    if (img.complete && img.naturalWidth > 0) {
      if (typeof img.decode === 'function') {
        void img.decode().then(done, done)
        return
      }
      done()
    }
  })
}

export function preloadImages(srcs: readonly string[]) {
  srcs.forEach((src) => {
    void preloadImage(src)
  })
}
